import { token as typeToken } from '../types';
import deepCopy from '../../../util/deepCopy';

const initialState = {
    token: {
        token: null,
        temp: null,
        expireTime: null
    }
};
const state = deepCopy(initialState);

const getters = {
    [typeToken.getters.get_nontemp]: state => {
        return state.token.temp ? null : state.token;
    },
    [typeToken.getters.get_temp]: state => {
        return state.token.temp ? state.token : null;
    }
};

const mutations = {
    [typeToken.mutations.set_nontemp]: (state, {token, expireTime}) => {
        state.token = {
            token: token || state.token.token,
            temp: false,
            expireTime: expireTime || state.expireTime
        };
    },
    [typeToken.mutations.set_temp]: (state, {token, expireTime}) => {
        state.token = {
            token: token || state.token.token,
            temp: true,
            expireTime: expireTime || state.expireTime
        };
    },
    [typeToken.mutations.reset]: (state) => {
        Object.keys(initialState).forEach(key => {
            state[key] = initialState[key];
        });
    }
};

const actions = {
    [typeToken.actions.set_nontemp]: (context, {token, expireTime}) => {
        context.commit(typeToken.mutations.set_nontemp, {token, expireTime});
    },
    [typeToken.actions.set_temp]: (context, {token, expireTime}) => {
        context.commit(typeToken.mutations.set_temp, {token, expireTime});
    },
    [typeToken.actions.reset]: (context) => {
        context.commit(typeToken.mutations.reset);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
